if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        this.errorHtml = this.querySelector('template')?.content?.firstElementChild?.cloneNode(true) || null;
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.requestVersion = 0;
        if (this.hasAttribute('available')) this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;
        this.dataset.variantId = String(variantId);
        const requestVersion = ++this.requestVersion;
        this.abortController?.abort();
        this.abortController = new AbortController();
        const rootUrl = this.dataset.rootUrl || '/';
        const variantSectionUrl = `${rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`}variants/${encodeURIComponent(variantId)}/?section_id=pickup-availability`;

        return fetch(variantSectionUrl, { signal: this.abortController.signal })
          .then((response) => {
            if (!response.ok) throw new Error(`Pickup availability request failed: ${response.status}`);
            return response.text();
          })
          .then((text) => {
            if (requestVersion !== this.requestVersion) return;
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((error) => {
            if (error?.name === 'AbortError' || requestVersion !== this.requestVersion) return;
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.requestVersion += 1;
          this.abortController?.abort();
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.removeAttribute('available');
        if (!(this.errorHtml instanceof Node)) return;
        this.appendChild(this.errorHtml.cloneNode(true));
        this.querySelector('button')?.addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        if (!sectionInnerHTML?.querySelector) {
          this.renderError();
          return;
        }
        const preview = sectionInnerHTML.querySelector('pickup-availability-preview');
        const newDrawer = sectionInnerHTML.querySelector('pickup-availability-drawer');
        if (preview?.querySelector('button') && !newDrawer) {
          this.renderError();
          return;
        }
        document.querySelector('pickup-availability-drawer')?.remove();
        if (!preview) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute('available', '');
        if (!(newDrawer instanceof Node) || !document.body) return;
        document.body.appendChild(newDrawer);
        const colorClasses = (this.dataset.productPageColorScheme || '').split(/\s+/).filter(Boolean);
        newDrawer.classList.add(...colorClasses);
        this.querySelector('button')?.addEventListener('click', (event) => {
          if (newDrawer.isConnected && typeof newDrawer.show === 'function') newDrawer.show(event.target);
        });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);
        this.querySelector('button')?.addEventListener('click', () => this.hide());
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(event) {
        const target = event.target;
        if (target instanceof Element && target !== this && !target.closest('pickup-availability-drawer') &&
            target.id !== 'ShowPickupAvailabilityDrawer') this.hide();
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
